var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnotation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4001 10.4V3.99999C14.4001 3.57565 14.2315 3.16868 13.9315 2.86862C13.6314 2.56856 13.2244 2.39999 12.8001 2.39999H3.2001C2.77575 2.39999 2.36878 2.56856 2.06873 2.86862C1.76867 3.16868 1.6001 3.57565 1.6001 3.99999V10.4C1.6001 10.8243 1.76867 11.2313 2.06873 11.5314C2.36878 11.8314 2.77575 12 3.2001 12H5.6001L8.0001 14.4L10.4001 12H12.8001C13.2244 12 13.6314 11.8314 13.9315 11.5314C14.2315 11.2313 14.4001 10.8243 14.4001 10.4ZM4.0001 5.59999C4.0001 5.38782 4.08438 5.18434 4.23441 5.03431C4.38444 4.88428 4.58792 4.79999 4.8001 4.79999H11.2001C11.4123 4.79999 11.6158 4.88428 11.7658 5.03431C11.9158 5.18434 12.0001 5.38782 12.0001 5.59999C12.0001 5.81217 11.9158 6.01565 11.7658 6.16568C11.6158 6.31571 11.4123 6.39999 11.2001 6.39999H4.8001C4.58792 6.39999 4.38444 6.31571 4.23441 6.16568C4.08438 6.01565 4.0001 5.81217 4.0001 5.59999ZM4.8001 7.99999C4.58792 7.99999 4.38444 8.08428 4.23441 8.23431C4.08438 8.38434 4.0001 8.58782 4.0001 8.79999C4.0001 9.01217 4.08438 9.21565 4.23441 9.36568C4.38444 9.51571 4.58792 9.59999 4.8001 9.59999H7.2001C7.41227 9.59999 7.61575 9.51571 7.76578 9.36568C7.91581 9.21565 8.0001 9.01217 8.0001 8.79999C8.0001 8.58782 7.91581 8.38434 7.76578 8.23431C7.61575 8.08428 7.41227 7.99999 7.2001 7.99999H4.8001Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnotation);
export default __webpack_public_path__ + "static/media/Annotation.3fc50872532c591bac0b16044502a925.svg";
export { ForwardRef as ReactComponent };